import { render, staticRenderFns } from "./WeitereInfosPanel.vue?vue&type=template&id=39bed945&scoped=true"
import script from "./WeitereInfosPanel.vue?vue&type=script&lang=js"
export * from "./WeitereInfosPanel.vue?vue&type=script&lang=js"
import style0 from "./WeitereInfosPanel.vue?vue&type=style&index=0&id=39bed945&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bed945",
  null
  
)

export default component.exports